export default "__VITE_ASSET__DPSmE6fs__"